export { default as Tabs } from "./Tabs";
export * from "./Tabs";
